import { CARD_TYPES, MAX_INSTALLMENTS, defaultInstallmentEnabled } from "../constants/paymentConstants";

export const convertBackendToFrontend = (installmentRates = []) => {
    const rates = {};
    installmentRates.forEach((r) => {
        const brand = (r.brand ?? r.cardBrand ?? "").toUpperCase();
        if (!rates[brand]) rates[brand] = {};
        rates[brand][r.installmentCount] = {
            id: r.id ?? null,
            value: Number(r.commissionPercent ?? r.commissionRate ?? 0).toFixed(2),
            enabled: r.enabled != null ? r.enabled : defaultInstallmentEnabled(brand)
        };
    });

    CARD_TYPES.forEach((card) => {
        if (!rates[card]) rates[card] = {};
        for (let i = 1; i <= MAX_INSTALLMENTS; i++) {
            if (!rates[card][i]) {
                rates[card][i] = { id: null, value: "0.00", enabled: defaultInstallmentEnabled(card) };
            }
        }
    });

    return rates;
};

export const convertFrontendToBackend = (ratesObj = {}) => {
    const list = [];
    Object.entries(ratesObj).forEach(([cardBrand, counts]) => {
        Object.entries(counts).forEach(([instCnt, { id, value, enabled }]) => {
            if (value != null && value !== "") {
                const commission = parseFloat(value);
                if (!Number.isNaN(commission)) {
                    list.push({
                        id,
                        cardBrand,
                        installmentCount: parseInt(instCnt, 10),
                        commissionPercent: commission,
                        enabled: enabled
                    });
                }
            }
        });
    });
    return list;
};

export const groupInstallmentsByCard = (installmentRates) => {
    if (!installmentRates) return {};
    return installmentRates.reduce((acc, rate) => {
        if (!acc[rate.cardBrand]) acc[rate.cardBrand] = [];
        if (rate.enabled) acc[rate.cardBrand].push(rate);
        return acc;
    }, {});
};

export const getCardBrandColor = (brand) => {
    const colors = {
        VISA: "primary",
        MASTERCARD: "warning",
        AMERICAN_EXPRESS: "info",
        WORLD: "success",
        TROY: "secondary",
        MAXIMUM: "danger"
    };
    return colors[brand] || "dark";
};

export const getCardBrandName = (brand) => {
    const names = {
        VISA: "Visa",
        MASTERCARD: "Mastercard",
        AMERICAN_EXPRESS: "American Express",
        WORLD: "World",
        TROY: "Troy",
        MAXIMUM: "Maximum"
    };
    return names[brand] || brand;
};